import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import { createAlphaValidator } from './alpha.validator';
import { createAlphanumValidator } from './alphanum.validator';
import { createAlphaExtendedValidator } from './alpha-extended.validator';
import { createRangeValidator } from './range.validator';
import { createDenyFutureDatesValidator } from './deny-future-dates.validator';
import { FormFieldConfig, ValidationSettingsOptions } from '@app/shared/forms/dynamic-form/fields.service';
import { createDenyPastDatesValidator } from './deny-past-dates.validator';
import { TimeZoneService } from '@app/services/time-zone.service';
import {
  SpecialValidatorFn,
  SpecialValidatorFnFactory,
} from '@app/shared/utils/special-validators/special-validators.model';
import { duplicateStringValidator } from '@app/shared/utils/special-validators/duplicate-string.validator';

class SpecialValidatorConfig {
  constructor(
    public type: SpecialValidationType,
    public createValidatorFn: SpecialValidatorFnFactory,
    public isPreInput: boolean,
  ) {}
}

const config = [
  new SpecialValidatorConfig(SpecialValidationType.Alpha, createAlphaValidator, true),
  new SpecialValidatorConfig(SpecialValidationType.AlphaNum, createAlphanumValidator, true),
  new SpecialValidatorConfig(SpecialValidationType.AlphaConfigurable, createAlphaExtendedValidator, true),
  new SpecialValidatorConfig(SpecialValidationType.Range, createRangeValidator, false),
  new SpecialValidatorConfig(SpecialValidationType.DenyFutureDates, createDenyFutureDatesValidator, false),
  new SpecialValidatorConfig(SpecialValidationType.DenyPastDates, createDenyPastDatesValidator, false),
  new SpecialValidatorConfig(SpecialValidationType.DuplicateString, duplicateStringValidator, false),
];

export function getSpecialValidatorFn(params: {
  type: SpecialValidationType;
  validationOptions?: ValidationSettingsOptions;
  onlyPreInput?: boolean;
  fieldConfig?: FormFieldConfig;
  timeZoneService?: TimeZoneService;
}): SpecialValidatorFn {
  if (!params) {
    return;
  }

  const cfg = config
    .filter((item) => (params.onlyPreInput ? item.isPreInput : item))
    .find((item) => item.type === params.type);
  return cfg && cfg.createValidatorFn(params.validationOptions, params.fieldConfig, params.timeZoneService);
}
